import { default as activateAdder } from './activateAdder';
import { default as addBlock } from './addBlock';
import { default as addBlockRemote } from './addBlockRemote';
import { default as addBlockResponse } from './addBlockResponse';
import { default as clearSelectedBlocks } from './clearSelectedBlocks';
import { default as copyBlocks } from './copyBlocks';
import { default as copyBlocksResponse } from './copyBlocksResponse';
import { default as cropImage } from './cropImage';
import { default as cropImageRemote } from './cropImageRemote';
import { default as cropImageResponse } from './cropImageResponse';
import { default as deactivateAdders } from './deactivateAdders';
import { default as deleteBlocks } from './deleteBlocks';
import { default as deleteBlocksRemote } from './deleteBlocksRemote';
import { default as deleteBlocksResponse } from './deleteBlocksResponse';
import { default as discardChanges } from './discardChanges';
import { default as discardChangesRemote } from './discardChangesRemote';
import { default as discardChangesResponse } from './discardChangesResponse';
import { default as fetchInitialDataResponse } from './fetchInitialDataResponse';
import { default as hideBlocks } from './hideBlocks';
import { default as hideBlocksRemote } from './hideBlocksRemote';
import { default as hideBlocksResponse } from './hideBlocksResponse';
import { default as importDocument } from './importDocument';
import { default as importDocumentRemote } from './importDocumentRemote';
import { default as importDocumentResponse } from './importDocumentResponse';
import { default as markBlocksAsNew } from './markBlocksAsNew';
import { default as markBlocksAsNewRemote } from './markBlocksAsNewRemote';
import { default as markBlocksAsNewResponse } from './markBlocksAsNewResponse';
import { default as publish } from './publish';
import { default as publishRemote } from './publishRemote';
import { default as publishResponse } from './publishResponse';
import { default as receiveBlocksRemote } from './receiveBlocksRemote';
import { default as saveChanges } from './saveChanges';
import { default as saveChangesRemote } from './saveChangesRemote';
import { default as saveChangesResponse } from './saveChangesResponse';
import { default as selectBlock } from './selectBlock';
import { default as selectBlocksMarkedAsNew } from './selectBlocksMarkedAsNew';
import { default as selectBlocksOfType } from './selectBlocksOfType';
import { default as selectBlocksUnderHeading } from './selectBlocksUnderHeading';
import { default as selectBlocksWithVisibility } from './selectBlocksWithVisibility';
import { default as setBlockBeingDragged } from './setBlockBeingDragged';
import { default as setBlockBeingMoved } from './setBlockBeingMoved';
import { default as setClosestAdderIndex } from './setClosestAdderIndex';
import { default as toggleImport } from './toggleImport';
import { default as transferBlocks } from './transferBlocks';
import { default as transferBlocksRemote } from './transferBlocksRemote';
import { default as transferBlocksResponse } from './transferBlocksResponse';
import { default as updateBlock } from './updateBlock';
import { default as updateBlockRemote } from './updateBlockRemote';
import { default as updateBlockResponse } from './updateBlockResponse';
import { default as updateBlockType } from './updateBlockType';
import { default as updateBlockTypeRemote } from './updateBlockTypeRemote';
import { default as updateOrder } from './updateOrder';
import { default as updateOrderRemote } from './updateOrderRemote';
import { default as updateOrderResponse } from './updateOrderResponse';
import { default as updateTitle } from './updateTitle';
import { default as updateTitleRemote } from './updateTitleRemote';
import { default as updateTitleResponse } from './updateTitleResponse';

export const editorHandlers = {
  activateAdder,
  addBlock,
  addBlockRemote,
  addBlockResponse,
  clearSelectedBlocks,
  copyBlocks,
  copyBlocksResponse,
  cropImage,
  cropImageRemote,
  cropImageResponse,
  deactivateAdders,
  deleteBlocks,
  deleteBlocksRemote,
  deleteBlocksResponse,
  discardChanges,
  discardChangesRemote,
  discardChangesResponse,
  fetchInitialDataResponse,
  hideBlocks,
  hideBlocksRemote,
  hideBlocksResponse,
  importDocument,
  importDocumentRemote,
  importDocumentResponse,
  markBlocksAsNew,
  markBlocksAsNewRemote,
  markBlocksAsNewResponse,
  publish,
  publishRemote,
  publishResponse,
  receiveBlocksRemote,
  saveChanges,
  saveChangesRemote,
  saveChangesResponse,
  selectBlock,
  selectBlocksMarkedAsNew,
  selectBlocksOfType,
  selectBlocksUnderHeading,
  selectBlocksWithVisibility,
  setBlockBeingDragged,
  setBlockBeingMoved,
  setClosestAdderIndex,
  toggleImport,
  transferBlocks,
  transferBlocksRemote,
  transferBlocksResponse,
  updateBlock,
  updateBlockRemote,
  updateBlockResponse,
  updateBlockType,
  updateBlockTypeRemote,
  updateOrder,
  updateOrderRemote,
  updateOrderResponse,
  updateTitle,
  updateTitleRemote,
  updateTitleResponse
};
